import { AxiosResponse } from 'axios'
import { UseQueryOptions } from 'react-query'
export const baseUrl = process.env.PUBLIC_URL

export * from './useEnums'
export * from './useVehicle'

export type QueryOptions = Omit<UseQueryOptions<AxiosResponse<any, any>, any, AxiosResponse<any, any>, any>, "queryKey" | "queryFn"> | undefined
export type GenericQueryOptions<T> = Omit<UseQueryOptions<AxiosResponse<T, any>, any, AxiosResponse<T, any>, any>, "queryKey" | "queryFn"> | undefined


export function appendToFormData(formData: FormData, data: any, parentKey?: string) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            // Pokud parentKey existuje, vytvoří klíč ve formátu 'parent[key]'. Jinak použije pouze 'key'.
            const fullKey = parentKey ? `${parentKey}[${key}]` : key;
            appendToFormData(formData, data[key], fullKey);
        });
    } else {
        if (parentKey) {
            // Pro primitivní typy nebo instance Date/File přidá hodnotu do FormData.
            formData.append(parentKey, data);
        }
    }
}